import React, { useEffect } from "react";
import {
  commonHeaderStyle,
  commonStyle,
  rowStyle2,
} from "../../Utility/Utility";
import "../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const PartBErrorModal = ({ open, setOpen }) => {
  const { partBError } = useSelector((state) => state.EinvReducerNew);

  const columns = [
    {
      dataField: "property",
      text: "Field Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "30%",
      },
    },
    {
      dataField: "message",
      text: "Error",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "70%",
      },
    },
  ];
  // useEffect(() => {
  //   console.log("Useffect open :", open);
  // }, [open]);

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Error"}</Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        {partBError?.length > 0 && (
          <div className="error-table ">
            <BootstrapTable
              keyField="property"
              data={partBError}
              columns={columns}
              rowStyle={rowStyle2}
            />
          </div>
        )}
      </MuiDialogContent>
    </Dialog>
  );
};

export default PartBErrorModal;
